import React, { useState } from "react";
import Colors from "../../Constants/Colors";
const RejectModal = ({
  isOpen,
  onClose,
  onSubmit,
  title = "Rejection Comment",
  placeholder = "Enter rejection comments...",
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  errorImg,
}) => {
  const [tempComment, setTempComment] = useState("");

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!tempComment.trim()) {
      if (setMessageBox && setIsMessageBoxVisible) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Please enter comment</span>
            </div>
          </div>
        );
        if (setActiveImg && errorImg) {
          setActiveImg(errorImg);
        }
      }
      return;
    }
    onSubmit(tempComment);
    setTempComment("");
  };

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 50,
        color: `${Colors.color1}`,
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "500px",
        }}
      >
        <h2 style={{ marginBottom: "15px" }}>{title}</h2>
        <textarea
          value={tempComment}
          onChange={(e) => setTempComment(e.target.value)}
          placeholder={placeholder}
          style={{
            width: "100%",
            minHeight: "100px",
            padding: "10px",
            marginBottom: "15px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            resize: "vertical",
          }}
        />

        <button
          className="testreportcard-cancel-btn"
          onClick={() => {
            setTempComment("");
            onClose();
          }}
        >
          Cancel
        </button>
        <button className="testreportcard-create-btn" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default RejectModal;
